// extracted by mini-css-extract-plugin
module.exports = {"container":"Pagination_container__1y5r1","activeClass":"Pagination_activeClass__2ShOG"};